import { AfterViewInit, Component } from '@angular/core';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
declare const tizen: any;

@Component({
  selector: 'app-exit-app',
  templateUrl: './exit-app.component.html',
  styleUrls: ['./exit-app.component.scss'],
})
export class ExitAppComponent implements AfterViewInit {
  constructor(
    private navigationService: NavigationLibraryService,
    private dialogService: DialogService
  ) {}

  ngAfterViewInit(): void {
    this.navigationService.focusContainer('exit-app-modal', true, 0);
  }

  async exitAction() {
    if (navigator.userAgent.includes('Tizen')) {
      tizen?.application.getCurrentApplication().exit();
    } else {
      window.close();
    }
  }

  cancelAction() {
    this.dialogService.closeWithResult(true);
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }
}
